import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

config.autoAddCss = false

    import  { faCookieBite as fortawesomefreesolidsvgicons_faCookieBite } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faCookieBite)

    import  { faCommentDots as fortawesomefreesolidsvgicons_faCommentDots } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faCommentDots)

    import  { faEnvelope as fortawesomefreesolidsvgicons_faEnvelope } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faEnvelope)

    import  { faGrinWink as fortawesomefreesolidsvgicons_faGrinWink } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faGrinWink)

    import  { faCalendar as fortawesomefreesolidsvgicons_faCalendar } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faCalendar)

    import  { faBicycle as fortawesomefreesolidsvgicons_faBicycle } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faBicycle)

    import  { faHandshake as fortawesomefreesolidsvgicons_faHandshake } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faHandshake)

    import  { faLock as fortawesomefreesolidsvgicons_faLock } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faLock)

    import  { faExclamationCircle as fortawesomefreesolidsvgicons_faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faExclamationCircle)

    import  { faMedal as fortawesomefreesolidsvgicons_faMedal } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faMedal)

    import  { faTrophy as fortawesomefreesolidsvgicons_faTrophy } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faTrophy)

    import  { faPoundSign as fortawesomefreesolidsvgicons_faPoundSign } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faPoundSign)

    import  { faStopwatch as fortawesomefreesolidsvgicons_faStopwatch } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faStopwatch)

    import  { faStar as fortawesomefreesolidsvgicons_faStar } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faStar)

    import  { faArrowDown as fortawesomefreesolidsvgicons_faArrowDown } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faArrowDown)

    import  { faRedo as fortawesomefreesolidsvgicons_faRedo } from '@fortawesome/free-solid-svg-icons'
    library.add(fortawesomefreesolidsvgicons_faRedo)

    import  { faCalendar as fortawesomefreeregularsvgicons_faCalendar } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faCalendar)

    import  { faUserCircle as fortawesomefreeregularsvgicons_faUserCircle } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faUserCircle)

    import  { faEdit as fortawesomefreeregularsvgicons_faEdit } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faEdit)

    import  { faTrashAlt as fortawesomefreeregularsvgicons_faTrashAlt } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faTrashAlt)

    import  { faPlusSquare as fortawesomefreeregularsvgicons_faPlusSquare } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faPlusSquare)

    import  { faTimesCircle as fortawesomefreeregularsvgicons_faTimesCircle } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faTimesCircle)

    import  { faArrowAltCircleLeft as fortawesomefreeregularsvgicons_faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faArrowAltCircleLeft)

    import  { faCheckCircle as fortawesomefreeregularsvgicons_faCheckCircle } from '@fortawesome/free-regular-svg-icons'
    library.add(fortawesomefreeregularsvgicons_faCheckCircle)

    import  { faDev as fortawesomefreebrandssvgicons_faDev } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faDev)

    import  { faFacebook as fortawesomefreebrandssvgicons_faFacebook } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faFacebook)

    import  { faTwitter as fortawesomefreebrandssvgicons_faTwitter } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faTwitter)

    import  { faInstagram as fortawesomefreebrandssvgicons_faInstagram } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faInstagram)

    import  { faYoutube as fortawesomefreebrandssvgicons_faYoutube } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faYoutube)

    import  { faGoogle as fortawesomefreebrandssvgicons_faGoogle } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faGoogle)

    import  { faCcVisa as fortawesomefreebrandssvgicons_faCcVisa } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faCcVisa)

    import  { faCcMastercard as fortawesomefreebrandssvgicons_faCcMastercard } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faCcMastercard)

    import  { faCcStripe as fortawesomefreebrandssvgicons_faCcStripe } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faCcStripe)

    import  { faStripe as fortawesomefreebrandssvgicons_faStripe } from '@fortawesome/free-brands-svg-icons'
    library.add(fortawesomefreebrandssvgicons_faStripe)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
